import { useRoutes } from "react-router-dom"

import { DetailSegmentSelectListener, SegmentSelectListener } from "@l2r-front/l2r-common"
import { MapAdapterBoundingBox, MapAdapterRoad } from "@l2r-front/l2r-networks"
import { NavigateWithParams, useUrlParams } from "@l2r-front/l2r-utils"

import { API_MODULE_VERTICAL_SIGNING } from "../../../../common/constants/modules"
import { VerticalSigningMobileContent } from "../../containers/VerticalSigningMobileContent"
import { VerticalSignPoleDetailsSidebar } from "../../containers/VerticalSignPoleDetailsSidebar"
import { VerticalSignSelectListener } from "../../containers/VerticalSignSelectListener"

import { VerticalSignPoleValidator } from "../VerticalSignPoleValidator"

export const VerticalSigningMobileRoutes = () => {
    const { getParams } = useUrlParams()
    const searchParams = getParams()

    const roadwayRoutes = useRoutes([
        {
            path: "/*",
            element: <>
                <MapAdapterBoundingBox module={API_MODULE_VERTICAL_SIGNING}  />
                <VerticalSigningMobileContent />
                <SegmentSelectListener />
            </>,
        },
        {
            path: "/code/:code",
            element: <>
                <MapAdapterBoundingBox module={API_MODULE_VERTICAL_SIGNING}  />
                <VerticalSigningMobileContent />
                <SegmentSelectListener />
            </>,
        },
        {
            path: "/:road",
            element: <>
                <DetailSegmentSelectListener />
                <MapAdapterRoad module={API_MODULE_VERTICAL_SIGNING} />
                <VerticalSigningMobileContent />
            </>,
        },
        {
            path: "/:road/:signId",
            element: <VerticalSignPoleValidator>
                <VerticalSignSelectListener />
                <VerticalSignPoleDetailsSidebar />
            </VerticalSignPoleValidator>,
        },
        {
            path: "/:road/code/:code",
            element: <>
                <DetailSegmentSelectListener />
                <MapAdapterRoad module={API_MODULE_VERTICAL_SIGNING} />
                <VerticalSigningMobileContent />,
            </>,
        },
        {
            path: "/:road/code/:code/:signId",
            element: <VerticalSignPoleValidator>
                <VerticalSignSelectListener />
                <VerticalSignPoleDetailsSidebar />,
            </VerticalSignPoleValidator>,
        },
        {
            path: "/:road/*",
            element: <NavigateWithParams replace to={`../:road?${searchParams}`} />,
        },
    ])

    return roadwayRoutes
}